"use client";

import { useEffect } from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { Menu, X } from "lucide-react";
import { useState } from "react";
function HeaderMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  if (loading) {
    return <div className="hidden md:flex gap-1">
        <div className="h-9 w-16 bg-primary/20 animate-pulse rounded-md" />
        <div className="h-9 w-16 bg-primary/20 animate-pulse rounded-md" />
        <div className="h-9 w-16 bg-primary/20 animate-pulse rounded-md" />
      </div>;
  }
  return <>
      {}
      <NavigationMenu viewport={false} className="hidden md:flex">
        <NavigationMenuList>
          {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
              <NavigationMenuLink asChild>
                <Link to={item.href || "#"} className="relative px-4 py-2 text-sm font-medium text-white uppercase tracking-wider transition-all duration-[var(--duration-medium)] hover:!bg-primary/10 focus:!bg-primary/10 after:absolute after:bottom-0 after:left-0 after:h-[2px] after:w-0 after:bg-primary after:transition-all after:duration-[var(--duration-medium)] hover:after:w-full focus:after:w-full">
                  {item.label}
                </Link>
              </NavigationMenuLink>
            </NavigationMenuItem>)}
        </NavigationMenuList>
      </NavigationMenu>

      {}
      <Button variant="ghost" size="icon" className="md:hidden hover:!bg-primary/10 focus:!bg-primary/10 text-white" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Toggle menu">
        {mobileMenuOpen ? <X className="size-6" /> : <Menu className="size-6" />}
      </Button>

      {}
      {mobileMenuOpen && <div className="absolute top-full left-0 right-0 bg-background border-t border-primary/20 md:hidden shadow-strong">
          <nav className="container mx-auto px-4 py-6">
            <ul className="flex flex-col gap-4">
              {menuItems.map((item, i) => <li key={item.id} data-index={i}>
                  <Link to={item.href || "#"} className="block px-4 py-2 text-sm font-medium text-primary uppercase tracking-wider transition-all duration-[var(--duration-medium)] hover:text-white focus:text-white hover:bg-primary/10 focus:bg-primary/10 rounded-md" onClick={() => setMobileMenuOpen(false)}>
                    {item.label}
                  </Link>
                </li>)}
            </ul>
          </nav>
        </div>}
    </>;
}
export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest("a[href]") as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute("href");
        if (!href) return;
        if (href === "/#") {
          e.preventDefault();
          window.scrollTo({
            top: 0,
            behavior: "smooth"
          });
          return;
        }
        let hash = "";
        if (href.startsWith("#")) {
          hash = href;
        } else if (href.startsWith("/") && href.includes("#")) {
          const [path, hashPart] = href.split("#");
          if (hashPart === "") {
            e.preventDefault();
            window.scrollTo({
              top: 0,
              behavior: "smooth"
            });
            return;
          }
          if (path === "/" || path === window.location.pathname) {
            hash = "#" + hashPart;
          }
        }
        if (hash && hash !== "#") {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: "smooth",
              block: "start"
            });
          }
        }
      }
    };
    document.addEventListener("click", handleAnchorClick);
    return () => document.removeEventListener("click", handleAnchorClick);
  }, []);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return <header id="header" className={`dark bg-background text-primary sticky top-0 z-50 w-full transition-all duration-[var(--duration-medium)] ${scrolled ? "shadow-medium border-b border-primary/20" : ""}`}>
      <div className="container mx-auto px-4 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {}
          <Link to="/" className="flex items-center focus:outline-none focus-ring">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1543299/img/vicistimtito_header_logo.png" alt="VycistimTito.cz Logo" className="h-7" />
          </Link>

          {}
          <MenuProvider menu_id="60" className="flex items-center">
            <HeaderMenuConsumer />
          </MenuProvider>

          {}
          <Button asChild className="hidden md:inline-flex bg-primary text-foreground-primary hover:bg-primary-hover focus:bg-primary-hover shadow-xs hover:shadow-medium hover:-translate-y-0.5 active:scale-95 active:translate-y-0 transition-all duration-[var(--duration-medium)]">
            <Link to="/ContactPage">Kalkulace zdarma</Link>
          </Button>
        </div>
      </div>
    </header>;
}